import { render, staticRenderFns } from "./AiChatBot.vue?vue&type=template&id=b9896e0e&"
import script from "./AiChatBot.vue?vue&type=script&lang=js&"
export * from "./AiChatBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports